import React, { useState, useEffect, useRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  OutlinedInput,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import axios from '../../../../utils/fvAxios';
import apiinfo from '../../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';

import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken } from "../../../../utils/Token";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


export default function ReportTrainingGuide({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const { register } = useForm();
  const [token,setToken]=useState(getToken())
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
      getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          // if(getOrgType()=="Client"){
          //   setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });
  }, []);

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  // const [selectAllChecked, setSelectAllChecked] = useState(false);
  // const [selectValue1, setSelectValue1] = useState([]);

  // const handleSelectAllChange = (event) => {
  //   const { checked } = event.target;
  //   setSelectAllChecked(checked);

  //   if (checked) {
  //     const allClientValues = client.map((item) => item.value);
  //     setSelectValue1(allClientValues);
  //   } else {
  //     setSelectValue1([]);
  //   }
  // };

  // const handleClientChange = (event) => {
  //   const { value } = event.target;

  //   const updatedSelected = value.includes('selectAll')
  //     ? value.filter((val) => val !== 'selectAll')
  //     : value;

  //   setSelectValue1(updatedSelected);
  //   setSelectAllChecked(
  //     updatedSelected.length === client.length && updatedSelected.length > 0
  //   );
  // };
  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleDocTypeChange = (event) => {
    setSelectedDocs(event.target.value);
  };
  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };  

  return (
    <>
        <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl+'TrainingGuide.aspx'
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: '25px' }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: '#3E4A62',
                  fontSize: '14px',
                  fontWeight: '500',
                  marginTop: '5px',
                  marginBottom: '5px',
                }}
              >
                Client
              </span>
              {/* <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register('client')}
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                  fontFamily: 'Arial, FontAwesome',
                }}
                size="small"
                name="clientIds"
                value={selectValue1}
                onChange={handleClientChange}
                input={<OutlinedInput label="Select Client" />}
                MenuProps={MenuProps}
                multiple
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return 'Select Client';
                  }
                  if (selected.includes('selectAll')) {
                    return 'All Clients';
                  }
                  return selected
                    .map((value) =>
                      client.find((item) => item.value === value).text
                    )
                    .join(', ');
                }}
              >
                <MenuItem value="selectAll">
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={handleSelectAllChange}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {client?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    <Checkbox checked={selectValue1.includes(item.value)} />
                    <ListItemText primary={item.text} />
                  </MenuItem>
                ))}
              </Select> */}
                 <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small'
                sx={{ width: "340px", overflow: "hidden" }}
                name="clientIds"
                value={selectedDocs}
                onChange={handleDocTypeChange}
                MenuProps={{ 
                  ref: menuListRef,
                  PaperProps:  MenuProps.PaperProps,
                  }
                }
                renderValue={(selected) =>
                  selected
                    .map((value) => client?.find((doc) => doc?.value === value)?.text)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">
               
                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedDocs?.length > 0 && selectedDocs?.length < client?.length
                    }
                    checked={selectedDocs?.length === client?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedDocs(client?.map((doc) => doc?.value));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedDocs([]);
                      }
                    }}
                  />
                     <label htmlFor="select-all-checkbox" style={{fontSize:"16px",fontWeight:"500",color:"rgba(0, 0, 0, 0.87)",width:"320px",cursor:"pointer"}}>
                    Select All
                  </label>
                </MenuItem>
                {client?.map((doc) => (
                  <MenuItem key={doc?.value} value={doc?.value}>
                    <Checkbox checked={selectedDocs?.indexOf(doc?.value) > -1} />
                    <ListItemText primary={doc.text} sx={{ overflowX: "hidden" }} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="login-button-request"
                type="submit"
                onClick={close}
                disabled={selectedDocs == ""}
              >
                Create Report
              </Button>
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token}/>
        </form>
        <br />
      </DialogContent>
    </>
  );
}
